module.exports = __webpack_public_path__ + "static/media/RR_icon_hpposition-rgb-300x300.88575b96.png";